import { customAlphabet } from 'nanoid';

const alphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export const CHAR_MAP = alphabet.split('');
export const VERIFICATION_POINTS = [3, 7, 11] as const;

// Original simple hash generation
export function generateRandomHash(length = 15): string {
  const nanoid = customAlphabet(alphabet, length);
  return nanoid();
}

// New verifiable hash generation
export function getVerificationChar(previousChars: string): string {
  const sum = previousChars
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  const position = sum % CHAR_MAP.length;
  const char = CHAR_MAP[position];
  if (!char) throw new Error('Invalid verification character position');

  return char;
}

export function generateVerifiableHash(length = 15): string {
  const nanoid = customAlphabet(alphabet, length - VERIFICATION_POINTS.length);
  let hash = nanoid();

  VERIFICATION_POINTS.forEach((pos, index) => {
    const beforePos = hash.slice(0, pos + index);
    const verificationChar = getVerificationChar(beforePos);
    hash =
      hash.slice(0, pos + index) + verificationChar + hash.slice(pos + index);
  });

  return hash;
}

export function isVerifiableHash(hash: string): boolean {
  if (!hash || hash.length < Math.max(...VERIFICATION_POINTS) + 1) return false;

  return VERIFICATION_POINTS.every((pos, index) => {
    const beforePos = hash.slice(0, pos + index);
    const expectedChar = getVerificationChar(beforePos);
    return hash[pos + index] === expectedChar;
  });
}
